import { render, staticRenderFns } from "./StakeContent.vue?vue&type=template&id=325e4022&scoped=true&"
import script from "./StakeContent.vue?vue&type=script&lang=ts&"
export * from "./StakeContent.vue?vue&type=script&lang=ts&"
import style0 from "./StakeContent.vue?vue&type=style&index=0&id=325e4022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e4022",
  null
  
)

export default component.exports